import Model, { attr, belongsTo, hasMany, type AsyncBelongsTo, type AsyncHasMany } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';
import type AreaMapModel from 'garaje/models/area-map';
import adapter from 'garaje/utils/decorators/adapter';

import type DeskModel from './desk';
import type EmployeeModel from './employee';
import type GenericResourceModel from './generic-resource';

const GENERIC_RESOURCE_SYSTEM_VERSION = 2;
@adapter('maps')
class DraftModel extends Model {
  // Attributes
  @attr('string') declare name: string;
  @attr('string') declare sharingStrategy: string;
  @attr('number') declare createdBy: number;
  @attr('number') declare lastUpdatedBy: number;
  @attr('number') declare versionNumber: number;
  @attr('number') declare createdAt: number;
  @attr('number') declare publishedAt: number;
  @attr('number') declare draftSystemVersion: number;
  @attr('number') declare markerSizeRatio: number;
  @attr('boolean') declare legacyMarkerSizing: boolean;

  // Relationships
  @belongsTo('area-map', { async: true, inverse: null }) declare originalAreaMap: AsyncBelongsTo<AreaMapModel>;
  @belongsTo('area-map', { async: true, inverse: 'drafts' }) declare draftAreaMap: AsyncBelongsTo<AreaMapModel>;
  @hasMany('desk', { async: true, inverse: 'draft' }) declare desks: AsyncHasMany<DeskModel>;
  @hasMany('generic-resource', { async: true, inverse: 'draft' })
  declare genericResources: AsyncHasMany<GenericResourceModel>;
  @hasMany('employee', { async: true, inverse: null }) declare sharedEmployees: AsyncHasMany<EmployeeModel>;

  async publish(payload: unknown): Promise<unknown> {
    return await apiAction(this, { method: 'PUT', path: 'publish', data: payload });
  }

  // Originally, draft maps didn't support generic resources. These were drafts with a system version of 1.
  // Drafts with a system version of 2 and above will have generic resources.
  get shouldLoadResources(): boolean {
    return this.draftSystemVersion >= GENERIC_RESOURCE_SYSTEM_VERSION;
  }
}

export default DraftModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    draft: DraftModel;
  }
}
